import gzOuterContainer from 'gazelle/src/components/outer-container/outer-container.module';
import gzAppNav from 'gazelle/src/components/app-nav/app-nav.module';
import gzViewContainer from 'gazelle/src/components/view-container/view-container.module';
import gzBodyWrap from 'gazelle/src/components/body-wrap/body-wrap.module';

export default angular.module('gazelle.bundles.frames', [
  gzOuterContainer,
  gzAppNav,
  gzViewContainer,
  gzBodyWrap
]).name;
